module.exports = __webpack_public_path__ + "img/181122_AM_Broschüre.e1903dfc.jpg";